module.exports = __webpack_public_path__ + "d7ff733ff1a91e5e4493d7a15ee16fc4.pdf";